import { action, computed, makeObservable, observable, toJS } from 'mobx';

type ValidatorFn<T> = (value: T) => string | null;

export class FormControl<T = any> {
   value: T;
   error: string = '';
   touched = false;
   dirty = false;
   private validators: ValidatorFn<T>[];

   constructor(
      initialValue: T,
      validators: ValidatorFn<T>[] = [],
      options: {
         unwrap: boolean;
      } = { unwrap: false }
   ) {
      function getObs() {
         if (Array.isArray(initialValue) && options.unwrap) {
            return observable.ref;
         }
         return observable;
      }

      makeObservable(this, {
         value: getObs(),
         error: observable,
         touched: observable,
         dirty: observable,
         setValue: action.bound,
         markAsTouched: action.bound,
         validate: action.bound,
         setValidators: action.bound,
         valid: computed,
         invalid: computed,
      });
      this.value = initialValue;
      this.validators = validators;
   }

   setValue(val: T) {
      if (val !== this.value) {
         this.value = val;
         this.dirty = true;
         this.validate();
      }
   }

   getRawValue(): T {
      return toJS(this.value);
   }

   markAsTouched() {
      this.touched = true;
   }

   validate() {
      for (const validator of this.validators) {
         const error = validator(this.value);
         if (error) {
            this.error = error;
            return;
         }
      }
      this.error = '';
   }

   get valid() {
      return !this.error;
   }

   get invalid() {
      return !!this.error;
   }

   setValidators(validators: ValidatorFn<T>[]) {
      this.validators = validators;
   }
}
